import { useEffect } from 'react';
import { NativeEventEmitter, NativeModules } from 'react-native';
import { atom, getDefaultStore } from 'jotai';

type FocusedTabState = Record<string, boolean>;

/**
 * tab용 atom. native viewWillAppear/viewWillDisappear 기반으로
 * instanceId별 tab focus 상태를 기록한다.
 */
export const focusedTabAtom = atom<FocusedTabState>({});

// brownfield에서 surface가 여러 개 떠 있어 useEffect가 다중 실행될 수 있다.
// NativeEventEmitter wrapper별 listenerCount는 분리돼 신뢰할 수 없으므로,
// 모듈 레벨 플래그로 앱 lifetime 동안 단 한 번만 등록되도록 가드한다.
let registered = false;

/**
 * tab용 Provider. viewWillAppear/viewWillDisappear 이벤트에 대해 싱글 listener를 등록하고,
 * instanceId별 tab focus 상태를 focusedTabAtom에 기록합니다.
 * App.tsx에 배치하세요. null을 반환하므로 리렌더를 유발하지 않습니다.
 */
export const FocusedTabProvider = () => {
  useEffect(() => {
    if (registered) return;
    registered = true;

    const emitter = new NativeEventEmitter(NativeModules.ReactNativeBridge);
    const store = getDefaultStore();

    emitter.addListener('viewDidAppear', (data: { instanceId: string }) => {
      store.set(focusedTabAtom, prev => {
        console.log('logAnalytics', 'viewWillAppear', data);
        return { ...prev, [data.instanceId]: true };
      });
    });

    emitter.addListener('viewWillDisappear', (data: { instanceId: string }) => {
      store.set(focusedTabAtom, prev => {
        console.log('logAnalytics', 'viewWillDisappear', data);
        return { ...prev, [data.instanceId]: false };
      });
    });
  }, []);

  return null;
};
